import * as yup from 'yup';
import dayjs from 'dayjs';

import { PortOptions } from '../Data.conf';

export const PilotiINConf = {
  schema: {
    check_in_date: yup
      .mixed()
      .nullable()
      .transform((value) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
          : null
      )
      .test('is-valid', 'Invalid date', function (value) {
        if (value) return !!dayjs(value).isValid();
        return true;
      })
      .required('Check in date is required or invalid'),
    check_in_time: yup.string().nullable().required('Check in time is required').test(
      'is-time',
      'Check in time format invalid',
      value => {
        if (!value) return true;
        return /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(value);
      }
    ),
    port: yup.object().nullable().required('Port is required'),
  },
  defaultValues: {
    check_in_date: dayjs(),
    check_in_time: null,
    port: null,
  },
  fields: [
    {
      id: 'service_divider',
      type: 'divider',
      label: 'Service',
      xs: 12,
    },
    {
      id: 'check_in_date',
      name: 'check_in_date',
      type: 'date',
      label: 'Check in date',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'check_in_time',
      name: 'check_in_time',
      type: 'time',
      label: 'Check in time',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'port',
      name: 'port',
      type: 'autocomplete',
      label: 'Port',
      options: PortOptions,
      required: true,
      xs: 12,
      sm: 6,
    },

  ],
};
